import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import axios from 'axios'
import Cookies from 'js-cookie'
import { isExpired } from 'react-jwt'

import { csrfHeader, isDemoSession } from '../auth/demo'
import { redirectToESIA } from './utils'

export enum TokenENUM {
  accessToken = 'accessToken',
}

/** Урлы в которых требуется токен */
const URLsWithToken = [
  'declaration/',
  'comments/new/',
  'api/programs/declaration',
  'api/events/event_declarations/',
  'child_info/',
  'esia_children/',
  'child_doc_info/',
]

/** Урлы в которых Content_Type: form-data */
const URLsFormData = ['comments/new/', 'declaration/']

const axiosTemplate = axios.create({
  baseURL:
    typeof window === 'undefined'
      ? process.env.INTERNAL_PORTAL_URL || process.env.NEXT_PUBLIC_REACT_APP_URL
      : process.env.NEXT_PUBLIC_REACT_APP_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

export const nextApi = axios.create({
  baseURL:
    typeof window === 'undefined'
      ? process.env.INTERNAL_NEXT_URL ||
        process.env.NEXT_PUBLIC_URL_TO_REDIRECT_AFTER_ESIA
      : '/',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

const fullFilledRequest = (config: AxiosRequestConfig): any => {
  const copyConfig = { ...config }
  const { url } = copyConfig

  if (url && URLsFormData.includes(url)) {
    copyConfig.headers = {
      ...copyConfig.headers,
      'Content-Type': 'multipart/form-data',
    }
  }

  if (url && URLsWithToken.includes(url)) {
    if (isDemoSession()) {
      const routes: Record<string, string> = {
        'comments/new/': '/api/comments/new',
        'declaration/': '/api/programs/declaration',
        'child_info/': '/api/child_info',
        'esia_children/': '/api/esia_children',
        'child_doc_info/': '/api/child_doc_info',
      }
      copyConfig.baseURL = '/'
      copyConfig.url = routes[url] || url
      copyConfig.headers = { ...copyConfig.headers, ...csrfHeader() }
      return copyConfig
    }
    const accessToken = Cookies.get(TokenENUM.accessToken)

    if (accessToken) {
      if (!isExpired(accessToken)) {
        copyConfig.headers = {
          ...copyConfig.headers,
          Authorization: `Token ${accessToken}`,
        }
      } else {
        redirectToESIA()
      }
    } else {
      redirectToESIA()
    }
  }
  return copyConfig
}

const rejectedResponse = (error: any) => Promise.reject(error)

const rejectedRequest = (error: unknown) => Promise.reject(error)

const fullFilledResponse = (res: AxiosResponse) => res

axiosTemplate.interceptors.request.use(fullFilledRequest, rejectedRequest)
axiosTemplate.interceptors.response.use(fullFilledResponse, rejectedResponse)

nextApi.interceptors.request.use((config) =>
  isDemoSession()
    ? { ...config, headers: { ...config.headers, ...csrfHeader() } }
    : config,
)

export default axiosTemplate
